<div class="hero flx-col">
	<swiper #swiper [pagination]="pagination" [autoplay]="{delay: 5000}" [slidesPerView]="1" (slideChange)="onSlideChange()">
	<ng-template swiperSlide *ngFor="let slide of slides; let i = index">
			<a [routerLink]="[getLink(slide.link)]" [queryParams]="getParams(slide.link)">
				<picture>
					<source media="(min-width: 600px)" [srcset]="slide.photos | img:'desktop':'webp':''" type="image/webp">
					<source media="(min-width: 600px)" [srcset]="slide.photos | img:'desktop':'normal':''">
					<source [srcset]="slide.photos | img:'mobile':'webp'" type="image/webp">
					<img [alt]="slide.title" [src]="slide.photos | img:'mobile':'normal'">
				</picture>
			</a>
	</ng-template>
	</swiper>
	<ul class="hero-navigation">
		<li *ngFor="let slide of slides; let i = index" [style.width.%]="(isMobile ? 100 : 100 / slides.length)" [class.active]="active_slide == i" (click)="slideTo(i)">
			<div>
				<h3 *ngIf="slide.title" [innerHtml]="slide.title"></h3>
				<p *ngIf="slide.description" [innerHtml]="slide.description"></p>
			</div>
			<a class="link" *ngIf="slide.buttontext" [routerLink]="[getLink(slide.link)]" [queryParams]="getParams(slide.link)">{{ slide.buttontext }}</a>
		</li>
	</ul>

	<div class="flx-row flx-btwn-cntr intro-header gutter">
		<h1 i18n="@@claim">Przyczepy do biznesu TEMARED</h1>
		<a class="stroked-button" [routerLink]="['/'+path_offer]" i18n="@@checkoffer">Sprawdź naszą ofertę</a>
	</div>

</div>
<div class="hidex flx-col flx-gap-quadruple">

	<div class="gutter flx-col flx-gap-default">
		<div class="fancy-box flx-dynamic flx-gap-default flx-strt-strt flx-btwn-end-md" (appDeferLoad)="fetchFeatured()">
			<div class="flx-col flx-gap-half">
				<h4 i18n>Nasza oferta</h4>
				<h2 i18n>NOWOŚCI I REKOMENDACJE</h2>
			</div>
			<a class="stroked-button show-all" [routerLink]="['/'+path_offer]" i18n="@@showall">Zobacz wszystkie</a>
		</div>

		<swiper [slidesPerView]="4" [spaceBetween]="16" [navigation]="true" [breakpoints]="{'@0.00': {slidesPerView: 2}, '@0.75': {slidesPerView: 2}, '@1.00': {slidesPerView: 3}, '@1.50': {slidesPerView: 4}}">
			<ng-template swiperSlide *ngFor="let product of products_featured; let j = index;">
				<app-product [product]="product"></app-product>
			</ng-template>
		</swiper>
	</div>

	<div class="video flx-col flx-cntr-end" (appDeferLoad)="initVideo()">
		<div class="box-16-9-wrap">
			<div class="box-16-9">
				<app-video *ngIf="video" [load]="video" [urls]="video_urls" [fit]="true"></app-video>
			</div>
		</div>
		<div class="video-caption bgprimary gutter gutter-v flx-col flx-cntr-strt flx-gap-default">
			<h2 i18n>Profesjonaliści wybierają Temared</h2>
			<p i18n> TEMARED od lat wspiera profesjonalistów polegających na wysokiej jakości i sprawdzonych rozwiązaniach. Nasze przyczepy to wsparcie transportowe do wszystkich zastosowań. </p>
			<a [routerLink]="['/'+path_about]" class="flat-button primary" i18n>POZNAJ NASZĄ FILOZOFIĘ</a>
		</div>
	</div>

	<div class="gutter flx-col flx-gap-default">
		<div class="fancy-box flx-dynamic flx-gap-default flx-strt-strt flx-btwn-end-md" (appDeferLoad)="setOffer()">
			<div class="flx-col flx-gap-half">
				<h4 i18n>Nasza oferta</h4>
				<h2 i18n>POZNAJ GAMĘ NASZYCH PRZYCZEP</h2>
			</div>
			<a class="stroked-button show-all" [routerLink]="['/'+path_offer]" i18n="@@showall">Zobacz wszystkie</a>
		</div>

		<div class="rooms">
			<swiper [slidesPerView]="6" [spaceBetween]="16" [navigation]="true" [breakpoints]="{'@0.00': {slidesPerView: 1}, '@0.75': {slidesPerView: 2}, '@1.00': {slidesPerView: 3}, '@1.50': {slidesPerView: 6}}">
				<ng-template swiperSlide *ngFor="let page of offer; let i = index">
					<a class="offer_{{ i+1}}" (click)="navigate(page.path, {})">
						<app-image [natural]="false" [url]="cdn +'/pages/'+ page.photos_directory + '/' + page.extra_field_3"></app-image>
						<span><button  class="flat-button accent">{{ page.name }}</button></span>
					</a>
				</ng-template>
			</swiper>
		</div>
	</div>

<div *ngIf="localeId != 'pl'"></div>

<div class="join-us flx-col flx-end-strt" *ngIf="localeId == 'pl'">
	<app-image [natural]="false" [url]="'/assets/team.jpg'"></app-image>
	<div class="join-us-box bgprimary gutter gutter-v  flx-col flx-cntr-strt flx-gap-default">
		<h2 i18n>Pracuj z nami</h2>
		<p i18n>
			W TEMARED tworzymy przyszłość transportu dla przedsiębiorstw i gospodarstw. Jeżeli podzielasz naszą misję to z pewnością znajdzie się miejsce dla Ciebie.
		</p><br><br>
		<a class="flat-button primary" [routerLink]="['/'+path_career]" i18n>
			Sprawdź aktualne ogłoszenia
		</a>
	</div>
</div>

</div>

<div class="distribution flx-dynamic flx-btwn-cntr bgdark">

	<h2 class="gutter" i18n>Międzynarodowa sieć dystrybucji</h2>
	<div class="flx-dynamic flx-cntr-cntr">
		<p class="gutter-v" i18n>
			TEMARED jest obecna w 36 krajach na całych świecie, posiadając ponad 200 punktów sprzedaży.
		</p>
		<div class="gutter gutter-v bgprimary">
			<a class="flat-button primary" [routerLink]="['/'+path_dealers]" i18n="@@finddealer">Znajdź dealera</a>
		</div>
	</div>
</div>

<div id="popup" class="flx-dynamic" *ngIf="popup">
	<button id="popup-close" mat-icon-button (click)="hidePopup()" aria-label="Zamknij">
		<svg class="icon icon-xl icon-close"><use xlink:href="#icon-close"></use></svg>
	</button>
	<app-image *ngIf="popup.photos?.items?.length" [natural]="false" [url]="cdn+'/'+popup.photos.items[0].module+'/'+popup.photos.items[0].dir+'/'+popup.photos.items[0].filename"></app-image>
	<div id="popup-content"><app-ve *ngIf="popup.content" [content]="popup.content"></app-ve></div>
</div>